import { gql } from '@apollo/client'

export const COPY_LOT = gql`
  mutation copyLot($lotId: String!, $portfolioId: String!) {
    copyLot(lotId: $lotId, portfolioId: $portfolioId) {
      _id
      address
      city
      state
      zip
      beds
      baths
      sqft
      lotSqft
      year
      description
      strategy
      status
      createdAt
      portfolio {
        _id
        name
      }
    }
  }
`
